/* eslint-disable max-lines-per-function */
import "azure-maps-control/dist/atlas.min.css";
import "./insMapWidget.scss";
import { AuthenticationType, data } from "azure-maps-control";
import { debounce } from "lodash";
import React, { useMemo, useState, useEffect } from "react";
import { AzureMap, AzureMapDataSourceProvider, AzureMapLayerProvider, AzureMapPopup, AzureMapsProvider } from "react-azure-maps";
import { useSelector } from "react-redux";
import { constMap, getIconPromises, optionsBubbleLayer, optionsClusterLayer, optionsCountSymbolLayer, optionsSymbolLayer } from "./ins-azure-map-widget-config";
import variables from "./insAzureMapsVariables.module.scss";
import { Region } from "common/regions";
import { InsLabelValueTooltip } from "components/widgets/base/common/insLabelValueTooltip";
import { language } from "language/default";
import { getConfig } from "plugins/config-loader";
const option = {
    authOptions: {
        authType: AuthenticationType.subscriptionKey,
        subscriptionKey: getConfig("REACT_APP_AZURE_MAPS_TOKEN")
    },
    language: Region.enUS,
    preserveDrawingBuffer: true,
    showFeedbackLink: false,
    showLogo: false
};
const TIMEOUT_PERIOD = 1000;
const PopupContent = (props) => React.createElement("div", { style: { padding: "10px" } },
    React.createElement(InsLabelValueTooltip, { ...props }));
export const InsAzureMapWidgetContent = (props) => {
    const theme = useSelector((state) => state.theme.themeName);
    const mapId = props.isMaximized ? "azureMapWidget_max" : "azureMapWidget";
    const [reRender, setReRender] = useState(0);
    const [popupOptions, setPopupOptions] = useState({ isVisible: false,
        options: { closeButton: false,
            fillColor: variables.tooltipBackground,
            pixelOffset: [0, constMap.PIXEL_OFFSET],
            position: [0, 0],
            showPointer: false },
        popupContent: React.createElement(PopupContent, { labelValuePairs: [] }) });
    const closePopup = () => {
        setPopupOptions({ ...popupOptions, isVisible: false });
    }, clusterClicked = (e) => {
        if (!e.pixel) {
            return;
        }
        const coordinates = e.map.pixelsToPositions([
            [e.pixel[0] + (constMap.CLUSTER_RADIUS * 2), e.pixel[1] + (constMap.CLUSTER_RADIUS * 2)],
            [e.pixel[0] - (constMap.CLUSTER_RADIUS * 2), e.pixel[1] - (constMap.CLUSTER_RADIUS * 2)]
        ]);
        const bounds = data.BoundingBox.fromPositions(coordinates);
        e.map.setCamera({
            bounds,
            padding: 10
        });
    }, clusterHovered = (e) => {
        if (e && e.shapes && e.shapes.length > 0 && e.shapes[0].properties?.cluster) {
            setPopupOptions({ ...popupOptions,
                isVisible: true,
                options: { ...popupOptions.options,
                    position: e.position },
                popupContent: React.createElement(PopupContent, { labelValuePairs: [[language.en.chart.map.tooltip.companies, e.shapes[0].properties.point_count_abbreviated]] }) });
        }
    }, symbolHovered = (e) => {
        if (e.shapes && e.shapes.length > 0) {
            const properties = e.shapes[0].getProperties();
            setPopupOptions({ ...popupOptions,
                isVisible: true,
                options: { ...popupOptions.options,
                    content: properties.tooltip,
                    pixelOffset: [0, constMap.PIXEL_OFFSET],
                    position: e.shapes[0].getCoordinates() },
                popupContent: React.createElement(PopupContent, { labelValuePairs: properties.customElements }) });
        }
    }, upMapIdle = (e) => {
        const mapContainer = e.map.getMapContainer()?.closest("[id^='azureMapWidget']");
        if (mapContainer) {
            mapContainer.setAttribute("data-map-rendered", "true");
        }
    }, upMapReady = (e) => {
        e.map.setCamera({
            bounds: data.BoundingBox.fromData(props.data?.map((x) => x.geometry) ?? []),
            padding: 50
        });
    };
    useEffect(() => {
        const handleCanvasTag = debounce(() => {
            setReRender((prevRender) => prevRender + 1);
        }, TIMEOUT_PERIOD);
        window.addEventListener("resize", handleCanvasTag);
        return () => {
            window.removeEventListener("resize", handleCanvasTag);
        };
    }, []);
    const icons = useMemo(() => getIconPromises(props.colorSet), [props.colorSet]);
    return React.createElement(AzureMapsProvider, { key: reRender },
        React.createElement("div", { id: mapId },
            React.createElement(AzureMap, { events: { idle: upMapIdle, ready: upMapReady }, imageSprites: icons, controls: [
                    {
                        controlName: "ZoomControl",
                        options: { position: "top-left" }
                    }
                ], styleOptions: { style: theme === "dark" ? "night" : "road" }, options: option },
                React.createElement(AzureMapPopup, { ...popupOptions }),
                React.createElement(AzureMapDataSourceProvider, { id: "BubbleLayer DataSourceProvider", collection: props.data, options: optionsClusterLayer },
                    React.createElement(AzureMapLayerProvider, { id: "BubbleLayer LayerProvider", options: optionsBubbleLayer, type: "BubbleLayer", events: {
                            click: clusterClicked,
                            mouseenter: clusterHovered,
                            mouseleave: closePopup
                        } }),
                    React.createElement(AzureMapLayerProvider, { id: "BubbleLayer2 LayerProvider", options: optionsCountSymbolLayer, type: "SymbolLayer" }),
                    React.createElement(AzureMapLayerProvider, { id: "BubbleLayer3 LayerProvider", events: {
                            mouseenter: symbolHovered,
                            mouseleave: closePopup
                        }, options: optionsSymbolLayer, type: "SymbolLayer" })))));
};
